import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ServiceBase } from "./servicebase";
import { SessionService } from "./sessionservice";

@Injectable()
export class ClaimStatsService extends ServiceBase {
  
  constructor(private http: HttpClient, private sessionService:SessionService) {
    super();
  }

  getStats() {
    const params = new HttpParams()
                        .set('userId', this.sessionService.userId)
                        .set('userOrg', this.sessionService.userOrg);
    return this.http.get(this.apiBaseUrl + 'claimstats', {params});
  }
}
